import React, { useContext } from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import AuthAPI from '../services/api/auth-api';
import { AuthContext } from './context/auth-context';
import Logger from '../utils/logger';

export default function SignIn() {
  const auth = useContext(AuthContext);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const environment = process.env.NODE_ENV;
    Logger.debug('Login attempt', { environment });
    const data = new FormData(event.currentTarget);
    const email = data.get('email');
    const password = data.get('password');
    // Normalize email to lowercase for case-insensitive login
    const normalizedEmail = email ? email.toLowerCase().trim() : email;
    Logger.userAction('User login attempt', { email: normalizedEmail });

    try {
      const loginInfo = await AuthAPI.login(normalizedEmail, password);
      Logger.info('Login successful', {
        userId: loginInfo.userId,
        email: normalizedEmail,
      });
      var tokenExpires = new Date();
      tokenExpires.setHours(
        tokenExpires.getHours() + loginInfo.tokenExpiresHours
      );
      Logger.debug('Token expiration set', { expiresAt: tokenExpires });
      auth.login(
        loginInfo.userId,
        loginInfo.email,
        loginInfo.token,
        tokenExpires,
        loginInfo.firstName,
        loginInfo.lastName,
        loginInfo.isAdmin,
        loginInfo.isTimecard,
        loginInfo.isWorkflow,
        loginInfo.isAnalytics,
        loginInfo.isSuperAdmin ?? false,
        loginInfo.reset_password,
        loginInfo.employeeId,
        loginInfo.userRecordId,
        loginInfo.homeUnion
      );
    } catch (err) {
      Logger.error('Login failed', err, { email: normalizedEmail });
      // Show specific error message from server if available
      const errorMessage =
        err.response?.data?.error ||
        err.response?.data?.message ||
        'Incorrect username or password';
      alert(errorMessage);
    }
    return;
  };

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          Sign in
        </Typography>
        <Box
          component="form"
          onSubmit={handleSubmit}
          noValidate
          sx={{ mt: 1 }}
        >
          <TextField
            margin="normal"
            required
            fullWidth
            id="email"
            label="Email Address"
            name="email"
            autoComplete="email"
            autoFocus
          />
          <TextField
            margin="normal"
            required
            fullWidth
            name="password"
            label="Password"
            type="password"
            id="password"
            autoComplete="current-password"
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
          >
            Sign In
          </Button>
        </Box>
      </Box>
    </Container>
  );
}
